module.exports = __webpack_public_path__ + "src/images/products/active/8_Heritage 86 Hat.png";